import TableSessionsList from "@/components/patient/TableSessionsList";

const PatientSessionsList: React.FC = () => {
  return (
    <div className="w-full flex justify-center mt-12">
      <TableSessionsList />
    </div>
  );
};

export default PatientSessionsList;
